export const manifest = {
  screens: {
    scr_njgsiv: { name: "Home", route: "/" },
    scr_9r4ltg: { name: "Política de Privacidad", route: "/", state: {"view":"privacy"}, position: {"x":160,"y":1820} },
    scr_xl5el0: { name: "Términos de Servicio", route: "/", state: {"view":"terms"}, position: {"x":1560,"y":1820} },
  },
  sections: {
    sec_v80gxu: { name: "Legal & Policies", x: 0, y: 1600, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "screen", id: "scr_njgsiv" },
    { kind: "section", id: "sec_v80gxu", children: [
      { kind: "screen", id: "scr_9r4ltg" },
      { kind: "screen", id: "scr_xl5el0" },
    ] },
  ],
}
